import React from 'react'
import { Updater, async, fromJSX, Fun, IOWidget } from 'widgets-for-react'
import { PaginationLayout } from './paginationLayout'
import { PaginationState } from './paginationState'

export const paginationWidget =
  (
    currentPage: number,
    perPage: number,
    toPage: Fun<number, string>
  ): IOWidget<PaginationState, Updater<PaginationState>> =>
  (paginationState) =>
    async<number>(paginationState, n =>
      fromJSX(() => <PaginationLayout currentPage={currentPage} totalPages={Math.ceil(n / perPage)} toPage={toPage} />)
    )
